import { render, staticRenderFns } from "./right.vue?vue&type=template&id=57074b4a&scoped=true"
import script from "./right.vue?vue&type=script&lang=js"
export * from "./right.vue?vue&type=script&lang=js"
import style0 from "./right.vue?vue&type=style&index=0&id=57074b4a&prod&lang=scss"
import style1 from "./right.vue?vue&type=style&index=1&id=57074b4a&prod&scoped=true&lang=css"
import style2 from "./right.vue?vue&type=style&index=2&id=57074b4a&prod&lang=css"
import style3 from "./right.vue?vue&type=style&index=3&id=57074b4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57074b4a",
  null
  
)

export default component.exports